import { computed, toValue, type ComputedRef, type MaybeRefOrGetter } from 'vue'
import { useI18n } from 'vue-i18n'
import type { LocalizedString } from 'models'

export function useLocalizedString(
    value: MaybeRefOrGetter<LocalizedString | undefined>,
    fallbackKey: string,
): ComputedRef<string>
export function useLocalizedString(
    value: MaybeRefOrGetter<LocalizedString | undefined>,
): ComputedRef<string | undefined>
export function useLocalizedString(
    value: MaybeRefOrGetter<LocalizedString | undefined>,
    fallbackKey?: string,
): ComputedRef<string | undefined> {
    const { locale, t, te } = useI18n({ useScope: 'global' })

    return computed(() => {
        const val = toValue(value)
        const fb =
            fallbackKey !== undefined && te(fallbackKey)
                ? t(fallbackKey)
                : undefined

        if (!val) {
            return fb
        }

        return val[locale.value] || fb
    })
}
